import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';

function AdminApp() {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // 检查是否已经登录
  useEffect(() => {
    const checkAdminAuth = async () => {
      const savedToken = localStorage.getItem('adminToken');
      const savedAdmin = localStorage.getItem('adminInfo');
      
      if (savedToken && savedAdmin) {
        try {
          // 验证token是否仍然有效
          const response = await fetch('/api/admin/verify', {
            headers: {
              'Authorization': `Bearer ${savedToken}`
            }
          });
          
          const data = await response.json();
          
          if (data.success) {
            setAdmin(JSON.parse(savedAdmin));
            setToken(savedToken);
          } else {
            // Token无效，清除本地存储
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminInfo');
          }
        } catch (error) {
          console.error('验证管理员身份失败:', error);
          // 网络错误时也清除本地存储
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminInfo');
        }
      }
      
      setLoading(false);
    };

    checkAdminAuth();
  }, []);

  const handleLogin = (adminInfo, adminToken) => {
    setAdmin(adminInfo);
    setToken(adminToken);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminInfo');
    setAdmin(null);
    setToken(null);
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        加载中...
      </div>
    );
  }

  return (
    <div>
      {admin ? (
        <AdminDashboard admin={admin} onLogout={handleLogout} />
      ) : (
        <AdminLogin onLogin={handleLogin} />
      )}
    </div>
  );
}

export default AdminApp;